<template>
    <div class="contract-detail" v-bind:style="{'min-height': myHeight}">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="throw-lease" :display="modalState.throwLease" @modalStatus="closeModal('throwLease')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>退租點交</h1>
            <div class="content">
                確定要退租點交“{{contractDetail.houseName}}”的合約嗎？確定後將通知房客退租點交
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setThrowLease()">確認</button>
                <button class="border-button" @click="closeModal('throwLease')">取消</button>
            </div>
        </modal>
        <new-bill :cid="contractDetail.contractId" @saveBillStatus="getSaveBillStatus"></new-bill>
        <bill-detail :billId="contractDetail.billId" :phone="contractDetail.tenant.phoneNumber"></bill-detail>
        <div class="tool-bar-mask"></div>
        <div v-if="errorCode != 221019" class="contract-detail-house-head">
            <h1 class="page-title">{{contractDetail.houseName}}</h1>
            <div class="btn-group">
                <button class="border-button">
                    <img src="@/assets/img/icon/plus_green.svg" alt="">
                    新增記帳
                </button>
                <button class="default-button" @click="setNewBill()">
                    <img src="@/assets/img/icon/plus_white.svg" alt="">
                    新增帳單
                </button>
                <dot-large-drop-menu>
                    <ul >
                        <li v-if="contractDetail.contractDetail.isPaperContract" @click="getContractPDF(contractDetail.contractId)">紙本合約</li>
                        <li v-else @click="getContract(contractDetail.contractId)">查看合約</li>
                        <li @click="modalState.throwLease = true">退租點交</li>
                    </ul>
                </dot-large-drop-menu>
            </div>
        </div>
        <div v-if="errorCode != 221019" class="user-info">
            <span class="title">狀態</span>
            <span class="name">
                已成立的合約，剩餘 {{dateMinus}} 天到期
            </span>
        </div>
        <div v-if="errorCode != 221019" class="contract-detail-house-body">
            <toogle-block titleMsg="租客資料">
                <div class="table-list tanant-info">
                    <div class="table-list-title">
                        <span class="name">租客姓名</span>
                        <span class="phone">租客手機</span>
                        <!-- <span class="sex">性別</span> -->
                        <span class="id-num">身分證字號</span>
                        <span class="id-img">身分證圖片正反</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="name">{{contractDetail.tenant.tenantName}}</span>
                            <span class="phone">{{contractDetail.tenant.phoneNumber}}</span>
                            <!-- <span class="sex">-</span> -->
                            <span class="id-num">{{contractDetail.tenant.idNumber}}</span>
                            <span class="id-img">
                                <img :src="imageUrl(contractDetail.tenant.idCardFrontUrl)" alt="">
                                <img :src="imageUrl(contractDetail.tenant.idCardBackUrl)" alt="">
                            </span>
                        </div>
                    </div>
                </div>
            </toogle-block>
            <toogle-block titleMsg="合約資料">
                <div class="table-list contract-info">
                    <div class="table-list-title">
                        <span class="date">租約起訖日</span>
                        <span class="address">房源地址</span>
                        <span class="rent">租金</span>
                        <span class="desposit">押金</span>
                        <span class="rent-date">收租日</span>
                        <span class="amount">入住人數</span>
                        <span class="house">房源</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="date">{{getFormatDate(contractDetail.contractDetail.contractBeginTime)}} - {{getFormatDate(contractDetail.contractDetail.contractEndTime)}}</span>
                            <span class="address">{{contractDetail.contractDetail.address}}</span>
                            <span class="rent">{{contractDetail.contractDetail.rentMonthly}}</span>
                            <span class="desposit">{{contractDetail.contractDetail.rentDeposit}}</span>
                            <span class="rent-date">每月{{getDateNum(contractDetail.contractDetail.contractBeginTime)}}日</span>
                            <span class="amount">{{contractDetail.contractDetail.tenantNumber}} 人</span>
                            <span class="house">
                                {{contractDetail.contractDetail.houseName}}
                                <!-- <img src="@/assets/img/icon/arrow_right_gray.svg" alt=""> -->
                            </span>
                        </div>
                    </div>
                </div>
            </toogle-block>
            <toogle-block titleMsg="房源設定">
                <div class="table-list house-setting">
                    <div class="table-list-title">
                        <span class="name">租金包含</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="name">{{contractDetail.rentInclude}}</span>
                        </div>
                    </div>
                </div>
                <div class="table-list house-setting">
                    <div class="table-list-title">
                        <span class="name">提供設備</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="name">{{contractDetail.equipment}}</span>
                        </div>
                    </div>
                </div>
                <div class="table-list house-setting">
                    <div class="table-list-title">
                        <span class="name">使用規範</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="name">{{contractDetail.rules}}</span>
                        </div>
                    </div>
                </div>
            </toogle-block>
            <toogle-block titleMsg="房源政策">
                <div class="table-list policy">
                    <div class="table-list-title">
                        <span class="name">自訂合約條款</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap col">
                            <span v-for="(policy, index) in contractDetail.policy" :key="index">{{policy}}</span>
                        </div>
                    </div>
                </div>
            </toogle-block>
            <toogle-block titleMsg="帳單紀錄">
                <div class="table-list bill-record">
                    <div class="table-list-title">
                        <span class="created">建立時間</span>
                        <span class="name">帳單名稱</span>
                        <span class="paid">繳款時間</span>
                        <span class="state">狀態</span>
                        <span class="amount">帳單金額</span>
                        <span class="action">操作</span>
                    </div>
                    <div id="bill-record" name="bill-record" class="table-list-body">
                        <div v-show="contractDetail.billRecord.length == 0" class="is-empty">0 筆資料</div>
                        <ul>
                            <li v-for="(bill,index) in contractDetail.billRecord" :key="index">
                                <span class="created">{{getFormatDate(bill.createdTime)}}</span>
                                <span class="name">{{bill.billName}}</span>
                                <span v-if="bill.actualPayTime" class="paid">{{getFormatDate(bill.actualPayTime)}}</span>
                                <span v-else class="paid">-</span>
                                <span class="state body blue" v-if="bill.billStatus == 'COMPLETELY_PAID'">已繳</span>
                                <span class="state body gray" v-if="bill.billStatus == 'UNPAID'">未繳</span>
                                <span class="state body red" v-if="bill.billStatus == 'OVERDUE'">欠款</span>
                                <span class="amount">{{bill.totalBillAmount}}</span>
                                <span class="action">
                                    <dot-dropmenu>
                                        <ul >
                                            <li @click="setBillDetail(bill.billCid), $analytics.logEvent('帳單明細', { screen_name: '帳單明細'})">帳單明細</li>
                                            <li>帳單刪除</li>
                                        </ul>
                                    </dot-dropmenu>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </toogle-block>
        </div>
    </div>
</template>
<script>
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import toogleBlock from '@/components/widge/toogleBlock.vue';
import newBill from '@/components/widge/newBill.vue';
import BillDetail from '@/components/widge/BillDetail.vue';
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiContractThrowLease,
    apiGetContractHouse,
    apiGetContractBill,
    apiGetContractTenant,
    apiGetContractPDF
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            today: new Date(),
            modalState: {
                throwLease: false
            },
            throwLease: {
                contractCid: this.$route.query.cid,
                name: null,
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            contractDetail: {
                contractId: this.$route.query.cid,
                billId: null,
                houseName: null,
                tenant: {},
                contractDetail: {},
                rentInclude: null,
                equipment: null,
                rules: null,
                policy: [],
                billRecord: []
            },
            errorCode: null,
            myHeight: (window.innerHeight) + 'px',
        }
    },
    mounted () {
        setTimeout(() => {
            if(this.$route.query.pos == 'bill'){
            window.location.hash = '#bill-record'
        }
        }, 500)
        
        this.getContractDetail()
        this.getContractTenant()
        this.getContractBill()
    },
    methods: {
        closeModal: function (type) {
            if( type == 'throwLease' ){
                this.modalState.throwLease = false
            }
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
            // let data = cid;
            // apiGetContract(data)
            // .then(res => {
            //     if( res.data.status == "SUCCESS" ){
            //         window.open(baseDomain+res.data.result.electronicContract, '合約詳情')
            //     }
            // })
            // .catch(err => {
            //     console.log(err)
            // })
        },
        getContractDetail: function (){
            let data = this.contractDetail.contractId
            apiGetContractHouse(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.contractDetail.contractDetail = res.data.result
                    this.getHouseDetail(res.data.result.houseCid)
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContractTenant: function () {
            let data = this.contractDetail.contractId
            apiGetContractTenant(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.contractDetail.tenant = res.data.result
                }else{
                    this.alart.fail = true
                    this.msg.error = res.data.errorMsg
                    this.errorCode = res.data.errorCode
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContractPDF: function (cid) {
            apiGetContractPDF(cid)
            .then( res => {
                console.log(res)
                
                if(res.status == 200){
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getHouseDetail: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    this.contractDetail.houseName = res.data.result.houseDetail.name
                    this.contractDetail.rentInclude = this.getHouseSetting(res.data.result.houseDetail.rentInclude)
                    this.contractDetail.equipment = this.getHouseSetting(res.data.result.houseDetail.equipment)
                    this.contractDetail.rules = this.getHouseSetting(res.data.result.houseDetail.rules)
                    this.contractDetail.policy = res.data.result.houseDetail.housePolicy
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getHouseSetting: function (arr) {
            let text = ''
            arr.map( (item, index) => {
                if(item.check == true){
                    text += item.itemName+ '、'
                }
            })
            return text.substring(0,text.length-1)
        },
        getContractBill: function () {
            let data = this.contractDetail.contractId
            apiGetContractBill(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.contractDetail.billRecord = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getSaveBillStatus: function (status) {
            if(status){
                this.getContractBill()
            }
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        getDateNum: function (time) {
            var date = new Date(time);
            return date.getDate();
        },
        setThrowLease: function () {
            let data = this.contractDetail.contractId
            console.log(data)
            apiContractThrowLease(data)
            .then(res => {
                console.log(res)
                if(res.data.status = "SUCCESS"){
                    this.modalState.throwLease = false
                    if(res.data.errorMsg){
                        this.alart.fail = true
                        this.msg.error = res.data.errorMsg
                    }
                }
            })
            .catch(err => {
                this.alart.fail = true
                this.msg.error = err
                console.log(err)
            })
        },
        setNewBill: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'newBill'})
            this.$store.dispatch('sendEventLog', 'CREATE_BILL')
        },
        setBillDetail: function (billCid) {
            this.contractDetail.billId = billCid
            this.$store.dispatch('setModalStatus', {state: true, type: 'billDetail'})
        },
        imageUrl: function (url) {
            return 'data:image/png;base64,'+url
        },
    },
    computed: {
        dateMinus: function () {
            let endDate = this.contractDetail.contractDetail.contractEndTime
            endDate = new Date(endDate);
            let now = new Date();
            let days = endDate.getTime() - now.getTime();
            let day = parseInt(days / (1000 * 60 * 60 * 24));
            return day;
        }
    },
    components: {
        DotLargeDropMenu,
        toogleBlock,
        'dot-dropmenu': DotDropMenu,
        newBill,
        BillDetail,
        AlartMsg,
        Modal,
    }
}
</script>
<style lang="scss" scoped>
    .contract-detail{
        .contract-detail-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            height: 44px;
            .btn-group{
                position: absolute;
                display: flex;
                align-items: center;
                top: -11px;
                right: 17px;
                .item-state{
                    margin-right: 24px;
                }
                .border-button,
                .default-button{
                    width: 104px;
                    margin-right: 16px;
                    padding: 9px 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .user-info{
            position: relative;
            display: flex;
            align-items: center;
            width: 1154px;
            height: 72px;
            margin-bottom: 60px;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0.5);
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 76px;
                height: 100%;
                margin-right: 24px;
                color: #a8a5a4;
                border-right:1px solid #f1f5f4;
            }
            .name{
                display: flex;
                align-items: center;
                margin-right: 18px;
                img{
                    margin-right: 8px;
                }
            }
        }
        .contract-detail-house-body{
            .table-list{
                .table-list-title{
                    padding: 24px 20px;
                }
                .table-list-body{
                    .wrap{
                        padding: 24px;
                        display: flex;
                        span{
                            display: flex;
                            align-content: center;
                        }
                    }
                    .wrap.col{
                        flex-direction: column;
                        span{
                            margin-bottom: 16px;
                        }
                        span:last-child{
                            margin-bottom: 0px;
                        }
                    }
                }
            }
            .table-list.tanant-info{
                .name{
                    width: 60px;
                    margin-right: 88px;
                }
                .phone{
                    width: 78px;
                    margin-right: 100px;
                }
                .sex{
                    width: 24px;
                    margin-right: 100px;
                }
                .id-num{
                    width: 78px;
                    margin-right: 100px;
                }
                .id-img{
                    >img{
                        width: 80px;
                        margin-right: 12px;
                    }
                }
            }
            .table-list.house-setting{
                margin-bottom: 20px;
            }
            .table-list.contract-info{
                .date{
                    width: 155px;
                    margin-right: 60px;
                }
                .address{
                    width: 280px;
                    margin-right: 62px;
                }
                .rent{
                    width: 45px;
                    margin-right: 50px;
                }
                .desposit{
                    width: 45px;
                    margin-right: 50px;
                }
                .rent-date{
                    width: 64px;
                    margin-right: 62px;
                }
                .amount{
                    width: 48px;
                    margin-right: 63px;
                }
                .house{
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                }
            }
            .table-list.bill-record{
                .table-list-body{
                    >ul >li{
                        padding: 24px 20px;
                    }
                }
                .name{
                    width: 98px;
                    margin-right: 136px;
                }
                .created{
                    width: 70px;
                    margin-right: 146px;
                }
                .amount{
                    width: 52px;
                    margin-right: 142px;
                }
                .paid{
                    width: 70px;
                    margin-right: 146px;
                }
                .state{
                    width: 76px;
                    margin-right: 146px;
                }
                .state.body{
                    height: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                }
                .state.blue{
                    background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
                }
                .state.red{
                    background-color: rgba(255, 146, 117, 0.1);
                    color: #fc7171;
                }
                .state.gray{
                    background-color: #f3f3f3;
                    color: #676362;
                }
            }
        }
        #modal.throw-lease{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    .contract-detail.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            border-bottom: 1px solid #f0f0f0;
            margin-left: -39px;
        }
        .contract-detail-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            h1{
                position: fixed;
                top: 26px;
            }
            .btn-group{
                position: fixed;
                top: 19px;
                right: unset;
                margin-left: 872px;
                .save{
                    width: 104px;
                    margin-right: 16px;
                }
                .publish{
                    width: 118px;
                }
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/leaseManagement/contractDetail/contractDetailComp.vue